import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, Setting,
} from '@appblocks/codegeneration/types';
import Tibbit_16 from '@appblocks/codegeneration/Tibbits/Tibbit_16';

export default class Tibbit_17 extends Tibbit_16 {
    constructor() {
        super();
        this.id = 'tibbit_17';
        this.name = 'Tibbit 17';
    }
}
